import { apiClientTodoTd } from "./config";

/**
 * Create task TodoTD
 * @param { organizationId, title, description, due_date } params
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const createTask = async (params, successCallback = false, errorCallback = false) => {
	const { organizationId, ...body } = params;

	try {
		const response = await apiClientTodoTd.post(`/tasks`, body, {
			headers: { "X-Organization-Id": organizationId },
		});
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};

/**
 * Get task users list TodoTD
 * @param { page, per_page } queryParams
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const getTaskUsersList = async (
	queryParams,
	successCallback = false,
	errorCallback = false
) => {
	const { organizationId, ...params } = queryParams;

	try {
		const response = await apiClientTodoTd.get(`/organization/users`, {
			params,
			headers: { "X-Organization-Id": organizationId },
		});
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};
